module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_eight-6dd31eacdec4f03b9bd8189dc28e991b.svg";